// extracted by mini-css-extract-plugin
module.exports = {"formSearch":"formSearch--D1by4","virtualColumn":"virtualColumn--11wCc","table":"table--2QB-N","columnsSetting":"columnsSetting--3faJ9","tablePageHeader":"tablePageHeader--1FZoj"};